globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Statistics = appCustomerSpace.Controllers.Statistics || {};

appCustomerSpace.Controllers.Statistics.WebdirectoriesPerformanceController = (function(superClass) {

  utils.extend(WebdirectoriesPerformanceController, superClass);

  function WebdirectoriesPerformanceController() {
    return WebdirectoriesPerformanceController.__super__.constructor.apply(this, arguments);
  }

  $.extend(WebdirectoriesPerformanceController.prototype, {
    init: function(){
      var controller = this;
      controller.initDateRangePicker();
      $('.chart').each(function() {
        controller.displayChart($(this));
      });

      return WebdirectoriesPerformanceController.__super__.init.apply(this, arguments);
    },
    displayChart: function($container) {
      if($container.length) {
        var defaultOptions = {
          plotOptions: {
            area: {
              stacking: 'normal'
            }
          },
          credits: {enabled: false},
          title: false,
          tooltip: {
            headerFormat: '<b>{point.key}</b><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name} </td><td style="padding: 0 10px; text-align: right;"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          xAxis: {
            categories: $container.data('chart-x-axis-categories')
          },
          yAxis: {min: 0}
        }

        options = $.extend({}, defaultOptions, $container.data('chart-options'));
        options.series = $container.data('series');

        $.fn.highcharts.apply($container, [options]);
      }
    },

    initDateRangePicker: function() {
      var $container = $('#range-picker'),
          $form = $('form.form-date-range-filter'),
          statsParams = $container.data('stats-params');

      if(!$container.length) return;

      new DateRangePicker($container, statsParams, {
        ranges: this._ranges(statsParams['min_date'])
      }, function(start, end) {
        $form.find('.start-date-input').val(start.format('YYYY-MM-DD'));
        $form.find('.end-date-input').val(end.format('YYYY-MM-DD'));
        $form.trigger('submit');
      });
    },

    _ranges: function(minDate) {
      var me = this,
          ranges = {};

      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.all')] = [moment(new Date(minDate)), moment()]
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.thisWeek')] = [moment().startOf('isoWeek'), moment()];
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.lastWeek')] = [moment().startOf('isoWeek').subtract(1, 'week'), moment().subtract(1, 'week').endOf('isoWeek')];
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.twoWeeksAgo')] = [moment().startOf('isoWeek').subtract(2, 'week'), moment().subtract(2, 'week').endOf('isoWeek')];

      $.each([0, 1, 2, 3, 4], function(value) {
          var month = utils.capitalize(moment().subtract(value, 'month').format('MMMM YYYY'));
          ranges[month] = [moment().subtract(value, 'month').startOf('month'), (value == 0 ? moment() : moment().subtract(value, 'month').endOf('month'))];
      });

      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.lastSemester')] = [moment().subtract(6, 'months').startOf('month'), moment().subtract(1, 'month').endOf('month')];
      ranges[appCustomerSpace.Modules.Charts.lang.t('periodRanges.beforeLastSemester')] = [moment().subtract(1, 'year').startOf('month'), moment().subtract(7, 'months').endOf('month')];

      return ranges;
    }
  });

  return WebdirectoriesPerformanceController;
})(appCustomerSpace.Controllers.Statistics.MainController);
